module.exports = __webpack_public_path__ + "img/Profil_CS-Slimlineri_Small.cb64553f.jpg";